module.exports = __webpack_public_path__ + "static/media/RUKUNDOKEVIN.f7f61d6b.jpg";